import { render, staticRenderFns } from "./ActorBoard.vue?vue&type=template&id=12360c60&scoped=true&"
import script from "./ActorBoard.vue?vue&type=script&lang=js&"
export * from "./ActorBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12360c60",
  null
  
)

export default component.exports